/* angular:styles/component:css;ddcdce6928e1a48b3b2495697e772f9e37f88b005a09ea0ced613b054ae5025a;/Users/stevennaimark/devtoil/Ziptility/Bivvy/src/app/tasks/components/swimlane/swimlane.component.ts */
.cdk-drag-preview {
  box-sizing: border-box;
  border-radius: 4px;
  box-shadow:
    0 5px 5px -3px rgba(0, 0, 0, 0.2),
    0 8px 10px 1px rgba(0, 0, 0, 0.14),
    0 3px 14px 2px rgba(0, 0, 0, 0.12);
}
.cdk-drag-placeholder {
  opacity: 0;
}
.cdk-drag-animating {
  transition: transform 50ms cubic-bezier(0, 0, 0.2, 1);
}
.drop-list.cdk-drop-list-dragging .card:not(.cdk-drag-placeholder) {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
.enter-animation {
  animation: slide-fade 0.1s;
}
.leave-animation {
  animation: slide-fade-leave 0.1s;
}
@keyframes slide-fade {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes slide-fade-leave {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(20px);
  }
}
/*# sourceMappingURL=swimlane.component.css.map */
